
import React, { use, useEffect, useState } from "react";

import setting from "../../../assets/images/homepage/profile/setting.svg";
import settingDark from "../../../assets/images/homepage/profile/settingDark.svg";
import themes from "../../../assets/images/homepage/profile/theme.svg";
import themeDark from "../../../assets/images/homepage/profile/themeDark.svg";
// import download from "../../../assets/images/homepage/profile/dowload.svg";
// import downloadDark from "../../../assets/images/homepage/profile/downloadDark.svg";
import logout from "../../../assets/images/homepage/profile/logout.svg";
import logoutDark from "../../../assets/images/homepage/profile/logoutDark.svg";
import cloud from "../../../assets/images/homepage/profile/cloud.svg";
import cloudDark from "../../../assets/images/homepage/profile/cloudDark.svg";
import upgradeStar from "../../../assets/images/organisationProfile/pricing/starLight.svg";
import upgradeStarDark from "../../../assets/images/organisationProfile/pricing/starDark.svg";
import { Organization, ManageUser as MU } from "@induz/sdk";
import useTheme from "hooks/observer";
import { signInContext } from "context/SigninContext";
import { useNavigate } from "react-router-dom";

import "./profile.scss";
import StorageProgress from "../Storage/index";
import DarkModeSwitch from "components/DarkModeSwitch/index";
import useScreenMobile from "hooks/useScreen";
import LogoutModal from "components/Models/LogoutModal/index";
import { useContext } from "react";
function Profile({ settings, setSettings, setProfile, clearYsentinalHistory, onProfilePicLoad, canRenewPlan }) {
  const theme = useTheme();
  const { user, isTypeSelect, setIsTypeSelect } = useContext(signInContext);
  const navigate = useNavigate();



  const isMobile = useScreenMobile({ size: 992 });
  const [logoutModal, setLogoutModal] = useState(false);
  const [userName, setUserName] = useState("Loading...");
  const [profilePicUrl, setProfilePicUrl] = useState(null);
  const { userMail } = useContext(signInContext);
  const userType = sessionStorage.getItem("usertype");
  const isOrganizationUser = userType === "Employee";

  // Set isTypeSelect based on user type, but only if user is set
  useEffect(() => {
    if (user) {
      if (user instanceof Organization) {
        setIsTypeSelect("org");
      } else {
        setIsTypeSelect("individual");
      }
    }
  }, [user, setIsTypeSelect]);
  const detectImageMimeType = (bytes) => {
    if (!bytes || bytes.length < 4) return "image/png";
    const signature = Array.from(bytes.slice(0, 12));
    if (signature[0] === 0x89 && signature[1] === 0x50 && signature[2] === 0x4e && signature[3] === 0x47) {
      return "image/png";
    }
    if (signature[0] === 0xff && signature[1] === 0xd8 && signature[2] === 0xff) {
      return "image/jpeg";
    }
    if (signature[0] === 0x47 && signature[1] === 0x49 && signature[2] === 0x46) {
      return "image/gif";
    }
    if (signature[0] === 0x42 && signature[1] === 0x4d) {
      return "image/bmp";
    }
    if (
      signature[0] === 0x52 && signature[1] === 0x49 && signature[2] === 0x46 && signature[3] === 0x46 &&
      signature[8] === 0x57 && signature[9] === 0x45 && signature[10] === 0x42 && signature[11] === 0x50
    ) {
      return "image/webp";
    }
    const asciiHead = String.fromCharCode(...bytes.slice(0, 200)).toLowerCase();
    if (asciiHead.includes("<svg")) {
      return "image/svg+xml";
    }
    return "image/png";
  };

  const getUserName = async () => {
    try {
      const details = await MU.getUserDetails(userMail);
      if (details instanceof Organization) {
        setUserName(details.getName?.() ?? details.name ?? "Organization");
        const logoBytes = details.getLogo?.();
        if (logoBytes && logoBytes.length > 0) {
          const base64Pic = btoa(String.fromCharCode(...logoBytes));
          const mimeType = detectImageMimeType(logoBytes);
          const url = `data:${mimeType};base64,${base64Pic}`;
          setProfilePicUrl(url);
          onProfilePicLoad?.(url);
        } else {
          setProfilePicUrl(null);
          onProfilePicLoad?.(null);
        }
      } else {
        const orgName = details.organization;
        setUserName(!orgName || String(orgName).trim() === "" ? "User" : orgName);
        const picBytes = details.getProfilePicture?.();
        if (picBytes && picBytes.length > 0) {
          const base64Pic = btoa(String.fromCharCode(...picBytes));
          const mimeType = detectImageMimeType(picBytes);
          const url = `data:${mimeType};base64,${base64Pic}`;
          setProfilePicUrl(url);
          onProfilePicLoad?.(url);
        } else {
          setProfilePicUrl(null);
          onProfilePicLoad?.(null);
        }
      }
    } catch (error) {
      console.error("Failed to get user/organization name:", error);
      setUserName(isTypeSelect === "individual" ? "User" : "Organization");
      setProfilePicUrl(null);
      onProfilePicLoad?.(null);
    }
  };

  useEffect(() => {
    getUserName();
  }, [isTypeSelect, userMail]);

  const logoutHandler = async () => {
    sessionStorage.removeItem("mail");
    sessionStorage.removeItem("memory");
    sessionStorage.removeItem("plan");
    sessionStorage.removeItem("storagePercentage");
    sessionStorage.removeItem("usertype");
    sessionStorage.removeItem("userDetails");
    // Clear YsentinalOne history on logout
    if (clearYsentinalHistory) {
      clearYsentinalHistory();
    }
    setLogoutModal(false);
    window.location.reload();
  };

  const handleUpgradePlan = (e) => {
    e.stopPropagation();
    setProfile(false);
    navigate("/upgrade-plan");
  };

  const handleRenewalPlan = (e) => {
    e.stopPropagation();
    setProfile(false);
    navigate("/upgrade-plan", { state: { renewalOnly: true } });
  };
  return (
    <div className="Profile">
      {isMobile && (
        <div className="ProfileNavigator">
          {/* <img src={leftArrow} alt="arrow" /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            onClick={() => setProfile(false)}
          >
            <g clipPath="url(#clip0_3254_74963)">
              <path
                d="M5 12H19"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 12L9 16"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 12L9 8"
                stroke={theme === "dark" ? "white" : "black"}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_3254_74963">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <p>Profile</p>
        </div>
      )}
      <div className="ProfileWrapper">
        <div className="ProfileTop">
          <div className="ProfileTopName">
            {profilePicUrl ? (
              <img src={profilePicUrl} alt="Profile" />
            ) : (
              <p>{sessionStorage.getItem("mail") === null ? "@" : sessionStorage.getItem("mail")[0].toUpperCase()}</p>
            )}
          </div>
          <div className="ProfileTopMail">
            <h1>{userName}</h1>
            <p>{sessionStorage.getItem("mail")}</p>
          </div>
        </div>
        <div className="ProfileMain">
          <div className="Wrapper ProfileStorage">
            <img src={theme === "light" ? cloud : cloudDark} alt="" />
            <StorageProgress />
          </div>
          <div
            className="Wrapper ProfileSettings"
            onClick={(e) => {
              e.stopPropagation(); // Prevent parent clicks from interfering

              setSettings(true);
              setProfile(false);
              // setTimeout(() => setProfile(false), 100); // Delayed closure of Profile
            }}
          >
            <img
              src={theme === "light" ? setting : settingDark}
              alt="setting"
            />
            <p>Settings</p>
          </div>
          <div className="Wrapper ProfileTheme">
            <div className="theme">
              <img src={theme === "light" ? themes : themeDark} alt="theme" />
              <p>Theme</p>
            </div>
            <DarkModeSwitch />
          </div>
          {!isOrganizationUser && (
            <div
              className="Wrapper ProfileUpgradePlan"
              onClick={handleUpgradePlan}
            >
              <img
                src={theme === "light" ? upgradeStar : upgradeStarDark}
                alt="upgrade"
              />
              <p>Upgrade Plan</p>
            </div>
          )}
          {canRenewPlan && (
            <div
              className="Wrapper ProfileUpgradePlan"
              onClick={handleRenewalPlan}
            >
              <img
                src={theme === "light" ? upgradeStar : upgradeStarDark}
                alt="renew"
              />
              <p>Renewal Plan</p>
            </div>
          )}
          {/* <div className="Wrapper ProfileInstall">
            <img
              src={theme === "light" ? download : downloadDark}
              alt="download"
            />
            <p>Install desktop app</p>
          </div> */}
          <div
            className="Wrapper ProfileLogout"
            onClick={() => {
              setLogoutModal(true);
            }}
          >
            <img src={theme === "light" ? logout : logoutDark} alt="logout" />
            <p
              style={{ color: theme === "light" ? "#DC1818" : "#BE2828" }}
            >
              Logout
            </p>
          </div>
        </div>
      </div>
      {logoutModal && (
        <LogoutModal
          setLogoutModal={setLogoutModal}
          logoutHandler={logoutHandler}
        />
      )}
    </div>
  );
}

export default Profile;
